import React, { useState } from 'react';
import { CheckboxButton } from './styles';
export var Checkbox = function () {
    var _a = useState(false), checked = _a[0], setChecked = _a[1];
    return (React.createElement(CheckboxButton, { type: "checkbox", checked: checked, onChange: function () { return setChecked(!checked); } }));
};
